export default __webpack_public_path__ + "static/icon-15-2-c373ad0660150b01a510d0bd1c479dd6.png";